import { defineMessages } from 'react-intl';

/**
 * Intl messages for the Summary step (step 5) chrome. Per-meter copy lives in
 * the content registry (`summaryStep`); these strings are meter-agnostic.
 */
export const messages = defineMessages({
	noProductsSelected: {
		id: 'ubp.calculator.summary.noProductsSelected',
		defaultMessage: 'No products selected',
	},
	noProductsSelectedNote: {
		id: 'ubp.calculator.summary.noProductsSelectedNote',
		defaultMessage: 'Go back to the Allowance step to pick one.',
	},
});
